module.exports = "/_next/static/media/76323d67c4d2c0fad56078831b0b96c0.svg";